import calendarDirective from './tc-calendar.component';

let tcCalendarWidget = angular.module('tcCalendar', ['ui.bootstrap'])
  .directive('tcCalendar', calendarDirective);

export default tcCalendarWidget;



// WEBPACK FOOTER //
// ./client/common/directives/calendar/tc-calendar.js